export const storagePathName = 'cloud_storage'